import MasterTypeModel from '../Apis/MasterType'
import Controller from './Controller'

export default class MasterTypeController extends Controller {
  constructor() {
    super(new MasterTypeModel())
  }
}
